<template>
  <div>
    <v-card flat :loading="loading" @mouseenter="mouseOver">
      <Submenu :parentData="name" @chartTitle="setTitle" />
      <div class="component-title timeframe">
        <div class="float-left mr-2">
          <v-select
            v-model="timeframe"
            :items="timeframes"
            return-object
            background-color="#404855"
            solo
            flat
          >
            <template v-slot:selection="{item}">
              <div class="pl-font float-left mr-1">{{item.text}}</div>
              <div class="text-info float-left">TF</div>
            </template>

            <template v-slot:item="{item}">
              <v-divider class="mb-2"></v-divider>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>
                    <div class="pl-font float-left mr-1">{{item.text}}</div>
                    <div class="text-info float-left">TF</div>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-select>
        </div>
        <div class="float-left">
          <b>{{title}}</b>
        </div>
      </div>

      <Chart @switch="switchChart" :timeframe="timeframe.value" />
      <div v-if="title == ''" class="nodata text-info">
        <div class="bold" style="font-size:20px">NO MARKETS AVAILABLE</div>
        <div>
          Connect your trading platform first.
          <span
            class="more"
            @click="showTutorial = true"
          >How to?</span>
        </div>
      </div>
    </v-card>
    <Tutorial @close="showTutorial = false" :show="showTutorial" title="Connect to platform" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Tutorial from "@/components/videotutorial";
import Chart from "@/components/Chart/";
import Submenu from "@/components/SubmenuChart/";
export default {
  components: {
    Tutorial,
    Chart,
    Submenu
  },
  data() {
    return {
      timeframe: null,
      timeframes: [
        { text: "5sec", value: 5 },
        { text: "30sec", value: 30 },
        { text: "1min", value: 60 },
        { text: "3min", value: 180 },
        { text: "5min", value: 300 },
        { text: "10min", value: 600 }
      ],
      showTutorial: false,
      title: "",
      name: "Section0",
      loading: false
    };
  },
  filters: {
    addplus(value) {
      if (value > 0) {
        return `+${value}`;
      } else return value;
    }
  },
  watch: {
    timeframe(newVal, oldVal) {
      if (oldVal) {
        this.$settings("timeframe", newVal);
      }
    }
  },
  computed: {
    ...mapGetters(["markets", "userSubmenus", "settings"])
  },
  mounted() {
    this.timeframe = this.settings.timeframe;
  },
  methods: {
    switchChart(data) {
      this.loading = data;
    },
    setTitle(data) {
      if (this.$store.getters.userSubmenus.Section0.items.length > 0)
        this.title = this.$store.getters.userSubmenus.Section0.items[data].user;
    },
    mouseOver() {
      this.$store.dispatch("resetActivity", { section: this.name });
    }
  }
};
</script>


<style scoped>
.nodata {
  width: 100%;
  text-align: center;
  position: absolute;
  left: 0px;
  top: 185px;
}
</style>
